import React, { FC } from "react";
import { makeStyles, Box } from "@material-ui/core";
import { motion } from "framer-motion";
import colors from "../constants/colors";

interface IButtonProps {
  onClick?: () => void;
  children: React.ReactNode;
  type?: "submit" | "button";
}

const Button: FC<IButtonProps> = ({ children, onClick, type = "button" }) => {
  const classes = styles();
  return (
    <Box className={classes.container}>
      <div className={classes.underlay}></div>
      <motion.button
        type={type}
        onClick={onClick}
        className={classes.button}
        whileTap={{ translateY: 5 }}
        transition={{ duration: 0.01 }}
      >
        {children}
      </motion.button>
    </Box>
  );
};

const styles = makeStyles(({ typography }) => ({
  container: {
    position: "relative",
  },
  button: {
    cursor: "pointer",
    width: "100%",
    height: "60px",
    borderRadius: "10px",
    borderColor: "transparent",
    backgroundColor: "black",
    color: "white",
    fontSize: "24px",
    fontFamily: typography.fontFamily,
    fontWeight: "bold",
    zIndex: 10,
    position: "relative",
  },
  underlay: {
    backgroundColor: colors.primary,
    borderRadius: "12px",
    width: "99.9%",
    height: "59px",
    background: "red",
    position: "absolute",
    top: "5px",
  },
}));

export default Button;
